import { TalkDeskWebChat } from './types';

declare global {
  interface Window {
    TalkdeskChatSDK: any;
    talkDeskWebChat: TalkDeskWebChat | null;
  }
}

export class TalkdeskChatbotPlugin {
  private static permission = false;
  constructor(perm: boolean, touchpointId?: string) {
    if (perm) {
      TalkdeskChatbotPlugin.permission = perm;
      if (navigator?.userAgent.indexOf('reactNativeWebview') === -1) {
        this.init(touchpointId);
      }
    } else {
      window.console.log('Chatbot has no permission/handle ');
    }
  }

  private init(touchpointId?: string) {
    const accessToken = sessionStorage.getItem('acp_access_token');
    let webchat: TalkDeskWebChat;
    let isChatOpen = false;
    (function (window, document, node, props, configs) {
      if (window.TalkdeskChatSDK) {
        // eslint-disable-next-line no-console
        console.error('TalkdeskChatSDK already included');
        return;
      }
      const divContainer = document.createElement('div');
      divContainer.id = node;
      document.body.appendChild(divContainer);
      const src =
        'https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js';
      const script = document.createElement('script');
      const firstScriptTag = document.getElementsByTagName('script')[0];
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.id = 'tdwebchatscript';
      script.src = src;
      script.async = true;
      if (firstScriptTag?.parentNode)
        firstScriptTag.parentNode.insertBefore(script, firstScriptTag);

      script.onload = function () {
        webchat = window.TalkdeskChatSDK(node, props);
        webchat.init(configs);
        window.talkDeskWebChat = webchat;

        // hide default td button
        const hideTalkdeskTrigger = () => {
          const triggerButton = document.querySelector(
            '#talkdesk-chat-widget-trigger'
          );
          if (triggerButton) {
            (triggerButton as HTMLElement).style.display = 'none';
          } else {
            // Retry if the widget hasn't loaded yet
            setTimeout(hideTalkdeskTrigger, 10);
          }
        };
        hideTalkdeskTrigger();

        webchat.onCloseWebchat = function () {
          isChatOpen = false;
          hideTalkdeskTrigger();
        };

        window.talkDeskWebChat.toggle = () => {
          if (!webchat) {
            // eslint-disable-next-line no-console
            console.warn('Chat widget not initialized yet');
            return;
          }

          if (isChatOpen) {
            webchat.close(); // or .minimize()
          } else {
            webchat.open();
          }
        };
        /*
         * Send custom data from your website to TalkDesk!
         * If you would like to do it, you need to remove the following commented code and
         * modify the webchat.setContextParam parameters to pass in the data you need.
         */
        function setContext() {
          const accessToken = sessionStorage.getItem('acp_access_token');
          webchat.setContextParam({
            access_token: accessToken ? JSON.parse(atob(accessToken)) : ''
          });
        }
        // Send data when the chat conversation is initiated
        // webchat.onConversationStart = function () {
        //   setContext();
        // };
        // Send data when the chat widget is open
        webchat.onOpenWebchat = function () {
          setContext();
          isChatOpen = true;
        };
      };
    })(
      window,
      document,
      'tdWebchat',
      {
        touchpointId: touchpointId ? touchpointId : '',
        accountId: '',
        region: 'td-us-1'
      },
      {
        enableValidation: false,
        enableEmoji: true,
        enableUserInput: true,
        enableAttachments: true,
        authentication: {
          type: 'jwt',
          token: accessToken ? JSON.parse(atob(accessToken)) : ''
        }
      }
    );
  }
}
